import { valNumber, valSchema, valString } from '@bymason-private/legacy-pattern-components';
import { convertToBytes } from '@bymason/utils';

export enum Fields {
  Name = 'name',
  Description = 'description',
  Threshold = 'threshold',
  Unit = 'unit',
  Domain = 'domain',
  Recipients = 'recipients',
}

const MAX_RULE_NAME_LENGTH = 60;
const MAX_RULE_DESCRIPTION_LENGTH = 1000;
const REQUIRED_MSG = 'Required';
const MIN_THRESHOLD_MSG = 'Threshold must be a positive number';
const VALUE_TOO_LARGE = 'Value is too large';
const COMMA_SEP_EMAIL_REGEXP = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/;

export const schema = valSchema().shape({
  [Fields.Name]: valString()
    .required(REQUIRED_MSG)
    .max(MAX_RULE_NAME_LENGTH, `Rule name length must be ${MAX_RULE_NAME_LENGTH} characters or less`)
    .label('Rule name'),
  [Fields.Description]: valString().max(
    MAX_RULE_DESCRIPTION_LENGTH,
    `Project description length must be ${MAX_RULE_DESCRIPTION_LENGTH} characters or less`
  ),
  [Fields.Threshold]: valNumber()
    .required(REQUIRED_MSG)
    .typeError(MIN_THRESHOLD_MSG)
    .min(0, MIN_THRESHOLD_MSG)
    .test('too_large', VALUE_TOO_LARGE, (val, context) => {
      return !(convertToBytes(val ?? 0, context.parent[Fields.Unit]) > Number.MAX_SAFE_INTEGER);
    }),
  [Fields.Unit]: valString(),
  [Fields.Domain]: valString(),
  [Fields.Recipients]: valString().matches(
    COMMA_SEP_EMAIL_REGEXP,
    'Must be valid email addresses seperated by commas'
  ),
});

export interface NotificationFormModel {
  [Fields.Name]: string;
  [Fields.Description]: string;
  [Fields.Threshold]: number | '';
  [Fields.Unit]: string;
  [Fields.Domain]: string;
  [Fields.Recipients]: string;
}

export const initialValues: NotificationFormModel = {
  [Fields.Name]: '',
  [Fields.Description]: '',
  [Fields.Threshold]: '',
  [Fields.Unit]: 'Bytes',
  [Fields.Domain]: 'account',
  [Fields.Recipients]: '',
};
